<template>
  <section class="walkin-modal">
    <header class="walkin-modal__header">
      <div>
        <p class="walkin-modal__eyebrow">Fila de espera</p>
        <h2>Registrar walk-in</h2>
        <p class="walkin-modal__copy">
          El backend registra la hora de llegada, envía el email con QR y coloca la visita en la lista de espera.
        </p>
      </div>
      <button type="button" class="walkin-modal__close" @click="$emit('close')">×</button>
    </header>

    <form class="walkin-form" @submit.prevent="submitWalkIn">
      <label>
        <span>Nombre</span>
        <input v-model.trim="form.name" type="text" required placeholder="Nombre del cliente" />
      </label>

      <label>
        <span>Email</span>
        <input v-model.trim="form.email" type="email" required placeholder="cliente@email.com" />
      </label>

      <label>
        <span>Teléfono</span>
        <input v-model.trim="form.phone" type="tel" required placeholder="7870000000" />
      </label>

      <label>
        <span>Cantidad de personas</span>
        <input v-model.number="form.people" type="number" min="1" required />
      </label>

      <label class="walkin-form__notes">
        <span>Comentarios</span>
        <textarea
          v-model.trim="form.specialNotes"
          rows="4"
          placeholder="Alergias, cumpleaños, observaciones o comentarios del equipo"
        />
      </label>

      <p class="walkin-form__note">
        El cliente entra a la fila por orden de llegada. La mesa se asigna después desde la lista de espera.
      </p>

      <div class="walkin-form__actions">
        <button type="button" class="btn ghost" @click="$emit('close')">Cancelar</button>
        <button type="submit" class="btn primary" :disabled="loading">
          <span v-if="loading">Registrando...</span>
          <span v-else>Registrar walk-in</span>
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { reactive, ref } from 'vue';
import { createWalkIn as createWalkInRequest } from '../services/api/adminReservations';

const createInitialForm = () => ({
  name: '',
  email: '',
  phone: '',
  people: 1,
  specialNotes: ''
});

export default {
  name: 'AdminWalkInModal',
  emits: ['close', 'saved'],
  setup(_, { emit }) {
    const form = reactive(createInitialForm());
    const loading = ref(false);

    const resetForm = () => {
      Object.assign(form, createInitialForm());
    };

    const submitWalkIn = async () => {
      if (!form.name || !form.email || !form.phone || !Number(form.people)) {
        alert('Completa nombre, email, teléfono y cantidad de personas.');
        return;
      }

      loading.value = true;
      try {
        const response = await createWalkInRequest({
          name: form.name,
          email: form.email,
          phone: form.phone,
          people: Number(form.people) || 0,
          specialNotes: form.specialNotes
        });

        resetForm();
        emit('saved', response);
      } catch (error) {
        console.error('Error al registrar el walk-in:', error);
        alert(error.message || 'No se pudo registrar el walk-in.');
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      loading,
      submitWalkIn
    };
  }
};
</script>

<style scoped>
.walkin-modal {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.walkin-modal__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.walkin-modal__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: rgba(15, 23, 42, 0.6);
}

.walkin-modal__copy {
  margin: 8px 0 0;
  color: rgba(15, 23, 42, 0.75);
}

.walkin-modal__close {
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: rgba(15, 23, 42, 0.7);
}

.walkin-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.walkin-form label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #0f172a;
  font-weight: 600;
}

.walkin-form input,
.walkin-form textarea {
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 14px;
  padding: 12px 14px;
  font: inherit;
  color: #0f172a;
  background: #fff;
}

.walkin-form__notes,
.walkin-form__note,
.walkin-form__actions {
  grid-column: 1 / -1;
}

.walkin-form__note {
  margin: 0;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.04);
  color: rgba(15, 23, 42, 0.72);
}

.walkin-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 720px) {
  .walkin-form {
    grid-template-columns: 1fr;
  }
}
</style>
